import { avatarStyle, StatusAvatarComponent } from '$synapse/core';
import { ExamStatus } from '$synapse/models';
import { Component, input } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrls: ['./status-chip.component.scss'],
  imports: [SHARED_IMPORTS, StatusAvatarComponent],
})
export class StatusChipComponent {
  readonly examStatus = input<ExamStatus>(undefined);
  readonly center = input<boolean>(true);
  readonly avatarStyle = avatarStyle;
}
